mutation CreateRole($roleInput: RoleInput!) {
  createRole(input: { roleInput: $roleInput }) {
    role {
      id
    }
  }
}
